import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common'

import { AngularSvgIconModule } from 'angular-svg-icon';
import { CfaNavigationModule } from './core/modules/cfa-navigation-module/cfa-navigation-module';
import { CfaNavigationWrapper } from '@emm/core/modules/cfa-navigation-module/navigation-wrapper/navigation-wrapper';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { EffectsModule } from '@ngrx/effects';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { StoreRouterConnectingModule, RouterState } from '@ngrx/router-store';
import { TreeModule} from '@ali-hm/angular-tree-component';

import { environment } from '@env';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler, plugin as BugsnagAngularPlugin } from '@bugsnag/plugin-angular';
import {TogglzService} from './core/services/togglz.service';


import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import {DynamicFormFieldService} from '@emm/shared/services/dynamic-form-field.service';
import {AuthModule} from '@emm/auth/auth.module';
import {RouterStoreEffects} from '@emm/core/services/effects/router-store.effects';
import {metaReducers, reducers} from '@emm/core/store/core.reducer';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {HttpRequestInterceptor} from '@emm/auth/http-request.interceptor';
import {AuthInterceptor} from '@emm/auth/auth.interceptor';
import {FormlyFilterWrapperComponent} from '@emm/shared/formly/formly-filter-wrapper/formly-filter-wrapper.component';
import {
    FormlyHorizontalWrapperComponent
} from '@emm/shared/formly/formly-horizontal-wrapper/formly-horizontal-wrapper.component';
import {validationMessages} from '@emm/shared/formly/validation-messages.util';
import {SharedModule} from '@emm/shared/shared.module';
import {CoreModule} from '@emm/core/core.module';
import {MenuPublishingService} from '@emm/core/services/menu-publishing.service';
import {MenuModule} from '@emm/menu/menu.module';
import {FormatTimezonePipe} from '@emm/shared/pipes/formatTimezone.pipe';
import {NutritionPublishingService} from '@emm/core/services/nutrition-publishing.service';

const bugsnagClient = Bugsnag.start({
    apiKey: environment.bugsnagApiKey,
    plugins: [BugsnagAngularPlugin]
});

// Okta Config
const oktaAuth = new OktaAuth({
    clientId: environment.oktaDetails.clientId,
    issuer: environment.oktaDetails.oktaIssuerUrl,
    redirectUri: environment.oktaDetails.redirectUrl,
    scopes: ['openid', 'email'],
    pkce: false,
    tokenManager: {autoRenew: true, storage: 'sessionStorage'},
    });
const moduleConfig: OktaConfig = { oktaAuth };


export function errorHandlerFactory() {
    return bugsnagClient.getPlugin('Angular');
}

@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        FormlyFilterWrapperComponent,
        // FormlyHorizontalWrapperComponent,
    ],
    exports: [],
    imports: [
        AngularSvgIconModule.forRoot(),
        AppRoutingModule,
        AuthModule,
        BrowserAnimationsModule,
        BrowserModule,
        CfaNavigationModule,
        ContextMenuModule,
        CommonModule,
        CoreModule,
        EffectsModule.forRoot([RouterStoreEffects]),
        FormlyMaterialModule,
        FormlyModule.forRoot({
            validationMessages,
            wrappers: [
                {
                    name: 'form-field-horizontal',
                    component: FormlyHorizontalWrapperComponent
                },
                {
                    name: 'form-field-filter',
                    component: FormlyFilterWrapperComponent
                }
            ]
        }),
        HttpClientModule,
        SharedModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictActionImmutability: true,
                strictActionSerializability: true,
                strictStateImmutability: true,
                strictStateSerializability: true
            },
        }),
        StoreDevtoolsModule.instrument({
            logOnly: environment.production,
            maxAge: 25,
            name: environment.oktaDetails.appName
        }),
        StoreRouterConnectingModule.forRoot({
            routerState: RouterState.Minimal
        }),
        TreeModule,
        OktaAuthModule.forRoot(moduleConfig),
        MenuModule,
        FormatTimezonePipe
    ],
    providers: [
        {
            provide: ApiUrl,
            useValue: environment.apiUrl
        },
        {
            provide: ErrorHandler,
            useFactory: errorHandlerFactory
        },
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        TogglzService,
        CfaNavigationWrapper,
        DynamicFormFieldService,
        MenuPublishingService,
        NutritionPublishingService,
        FormatTimezonePipe
    ]
})
export class AppModule {}
